<template>
  <product-form :loading="loading" @submit="createProduct"></product-form>
</template>
<script>
  import ProductForm from './ProductForm'
  import ProductService from 'src/services/ProductService'

  export default {
    name: 'product-create',
    components: {
      ProductForm
    },
    data() {
      return {
        loading: false
      }
    },
    methods: {
      async createProduct (product) {
        this.loading = true
        try {
          let {data} = await ProductService.create(product)
          this.$router.push(`/settings/products/${data.id}`)
        } finally {
          this.loading = false
        }

      }
    }
  }
</script>
